import { FC } from "react";
import { requestStatus } from "../../constants/statusConstants";

const BusinessTicketStatus: FC<any> = ({ status, isDemand, id }) => {
  if (status === requestStatus.submitted) {
    return <span className="flag status warning">{"Đang đợi duyệt"}</span>;
  } else if (status === requestStatus.preApproved) {
    return <span className="flag status warning">{"Đang đợi duyệt"}</span>;
  } else if (status === requestStatus.approved) {
    return <span className="flag status success">{"Đã duyệt"}</span>;
  } else if ([requestStatus.inProgress, "InProgress"].includes(status)) {
    return <span className="flag status info">{isDemand ? "Đang tiếp nhận" : "Đang thực hiện"}</span>;
  } else if (status === requestStatus.acceptance) {
    return <span className="flag status success">{isDemand ? "Đã tiếp nhận" : "Tiến hành nghiệm thu"}</span>;
  } else if (status === requestStatus.completed) {
    return <span className="flag status success">{isDemand ? "Tiến hành thực hiện" : "Đã duyệt"}</span>;
  } else if (status === requestStatus.rejected) {
    return <span className="flag status danger">{"Từ chối"}</span>;
  } else if (status === requestStatus.canceled) {
    return <span className="flag status default">{"Đã hủy"}</span>;
  } else if (status === requestStatus.revoked) {
    return <span className="flag status default">{"Thu hồi"}</span>;
  } else if ([requestStatus.draft, "draft"].includes(status)) {
    return <span className="flag status info">{"Đang soạn thảo"}</span>;
  }

  return <></>;
};

export default BusinessTicketStatus;
